"use client";
import styles from "./index.module.css";
import { closeIcon } from "../../assets";
import Image from "next/image";

const ChatHeader = ({
  chatAreaRef,
  chatInfo,
  isChatOpen,
  setSavedScrollTop,
  setReadyForPagination,
  closeChat,
}) => {
  const chatArea = chatAreaRef.current;

  const handleClose = () => {
    if (isChatOpen && chatArea) {
      const distanceFromBottom = chatArea.scrollHeight - chatArea.scrollTop;
      setSavedScrollTop(distanceFromBottom);
    }
    setReadyForPagination(false);
    closeChat();
  };

  return (
    <div className={styles.chatHeader}>
      <div className={styles.headerInfo}>
        <div className={styles.avatar}>
          {chatInfo?.imageUrl ? (
            <Image
              src={chatInfo?.imageUrl}
              alt={`${chatInfo?.name} avatar`}
              width={32}
              height={32}
              className={styles.avatarImg}
            />
          ) : (
            <div className={styles.avatarFallback}>
              {chatInfo?.name?.charAt(0) || "?"}
            </div>
          )}
        </div>
        <div className={styles.headerText}>
          <span className={styles.headerLogo}>{chatInfo?.name}</span>
          <span className={styles.headerSubtitle}>
            Chat with an admin of {chatInfo?.name}
          </span>
        </div>
      </div>

      <button
        onClick={handleClose}
        className={styles.closeBtn}
        aria-label="Close chat"
      >
        {closeIcon}
      </button>
    </div>
  );
};

export default ChatHeader;
